import { render, staticRenderFns } from "./CommunicationTypeModal.vue?vue&type=template&id=4bd0b2b7&scoped=true"
import script from "./CommunicationTypeModal.vue?vue&type=script&lang=js"
export * from "./CommunicationTypeModal.vue?vue&type=script&lang=js"
import style0 from "./CommunicationTypeModal.vue?vue&type=style&index=0&id=4bd0b2b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd0b2b7",
  null
  
)

export default component.exports